import { FaMoneyBillWave, FaRegCalendarAlt, FaHourglassEnd } from "react-icons/fa";

const SubscriptionBS = ({ transaction }) => {
  return (
    <div className="p-3" dir="rtl">

      {/* Header */}
      <div className="text-center mb-3">
        <h6 className="fw-bold mb-0">جزئیات اشتراک</h6>
        <small className="text-muted">رسید پرداخت</small>
      </div>

      <hr className="my-3 border-dashed" />

      {/* مبلغ */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center text-secondary gap-2">
          <FaMoneyBillWave />
          <span>مبلغ پرداخت</span>
        </div>
        <span className="fw-bold text-success">
          {transaction.payment} تومان
        </span>
      </div>

      {/* تاریخ خرید */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center text-secondary gap-2">
          <FaRegCalendarAlt />
          <span>تاریخ خرید</span>
        </div>
        <span>{transaction.buyDateTimeP}</span>
      </div>

      {/* تاریخ انقضا */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center text-secondary gap-2">
          <FaHourglassEnd />
          <span>تاریخ انقضا</span>
        </div>
        <span>{transaction.expireDateTimeP}</span>
      </div>

      {/* Status */}
      <div className="text-center mt-4">
        <span className="badge rounded-pill bg-success px-3 py-2">
          پرداخت موفق
        </span>
      </div>

    </div>
  );
};

export default SubscriptionBS;
